// extracted by mini-css-extract-plugin
export default {"item":"Jzb9V","itemIcon":"qEOlE","content":"P314p","textContent":"eZ8Bv","itemLabel":"jpR9a","bgc":"QInC8","addingText":"zkfMf","arrow":"LSbCN"};